import React from "react";
import { FormGroup, Input } from "reactstrap";
import moment from "moment";
import "react-image-crop/dist/ReactCrop.css";
class AuditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    let { user, categories } = this.props;
    if (!user) return null;
    if (!user.role) return null;
    if (!categories) return null;
    let minWeek = user.role.id === 600 ? 1 : 0;
    let maxWeek = user.role.id === 600 ? 4 : 52;
    for (var i = minWeek, weeksOption = []; i < maxWeek + 1; i++)
      weeksOption.push(i);
    return (
      <div>
        <div className="d-flex align-items-center justify-content-around">
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            disabled={this.props.loading}
            onClick={this.props.submitArticle}
          >
            保存
          </button>
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            onClick={this.props.togglePreview}
          >
            預覽
          </button>
        </div>

        <div className="d-flex align-items-center py-4">
          <div className="custom-control custom-radio">
            <input
              className="custom-control-input"
              id="customRadio1"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "draft"}
              value="draft"
              onChange={e => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio1">
              未審核
            </label>
          </div>
          <div className="custom-control custom-radio ml-2">
            <input
              className="custom-control-input"
              id="customRadio2"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "published"}
              value="published"
              onChange={e => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio2">
              通過發布
            </label>
          </div>
          <div className="custom-control custom-radio">
            <input
              className="custom-control-input"
              id="customRadio3"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "rejected"}
              value="rejected"
              onChange={e => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio3">
              審核不過
            </label>
          </div>
        </div>

        <p>
          預計價格：$
          {this.props.data.position === "top"
            ? 20 * this.props.data.weeks
            : 10 * this.props.data.weeks}
          + tax
        </p>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={e => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>

        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.handleCheckBoxChange(e)}
            disabled
          >
            {categories.map((cat, key) => (
              <option
                key={`cat-${cat.id}`}
                selected={
                  this.props.data.category_ids
                    ? this.props.data.category_ids.indexOf(cat.id) !== -1
                    : false
                }
                value={cat.id}
              >
                {cat.display_name}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect">選擇分類</label>
          <Input
            id="exampleFormControlSelect"
            type="select"
            onChange={e => this.props.onTextInputChange(e, "position")}
            disabled
          >
            <option
              selected={this.props.data.position === "right"}
              value={"right"}
            >
              側邊廣告
            </option>
            <option selected={this.props.data.position === "top"} value={"top"}>
              置頂廣告
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">期限</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.onTextInputChange(e, "weeks")}
          >
            {weeksOption.map(val => (
              <option
                key={`week-${val}`}
                selected={this.props.data.weeks === val}
                value={val}
              >
                {val === 0 ? "永久" : `${val}週`}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            聯繫人
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.contact}
            onChange={e => this.props.onTextInputChange(e, "contact")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            電話
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.phone}
            onChange={e => this.props.onTextInputChange(e, "phone")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            郵箱
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.email}
            onChange={e => this.props.onTextInputChange(e, "email")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            備註
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.note}
            onChange={e => this.props.onTextInputChange(e, "note")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            付款金額
          </label>
          <p>
            $
            {this.props.data.payment_amount
              ? this.props.data.payment_amount
              : "未知"}
          </p>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            開始時間
          </label>
          <p>
            {this.props.data.begin_date
              ? this.formatTime(this.props.data.begin_date)
              : "未知"}
          </p>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            結束時間
          </label>
          <p>
            {this.props.data.end_date
              ? this.formatTime(this.props.data.end_date)
              : "未知"}
          </p>
        </FormGroup>
      </div>
    );
  }
}

export default AuditForm;
